import { createDashboardGuideCallback } from '@screens/Dashboard/integrations/dashboardGuide';
import type { GuideIntegration, GuideRouter } from './guides.models';

/** Composition point for feature-owned actions, without putting them in global bootstraps. */
export function createAppGuideIntegration(router: GuideRouter): GuideIntegration {
  const navigate: GuideIntegration['navigate'] = (path, options) => {
    router.navigate(path, options);
  };
  return {
    navigate,
    callbacks: [createDashboardGuideCallback(navigate, () => router.state.location.state)],
  };
}
